import script from "./SpeakersView.vue?vue&type=script&setup=true&lang=js"
export * from "./SpeakersView.vue?vue&type=script&setup=true&lang=js"

import "./SpeakersView.vue?vue&type=style&index=0&id=532f028b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-532f028b"]])

export default __exports__